<script lang="ts">
	let random = (Math.random() * 100).toFixed(0);
</script>

<div
	class="text-[13px] relative w-full px-5 py-4 overflow-hidden border rounded border-gray-400 text-gray-500 {$$props.class ??
		''}">
	<ul class="grid w-full grid-cols-2 gap-3" style="margin: 0">
		<li>
			<a href="/security" class="flex flex-row items-center gap-1.5">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="20px"
					height="20px"
					viewBox="0 0 48 48">
					<defs>
						<mask id="ipTShield{random}">
							<path
								fill="#555"
								stroke="#fff"
								stroke-linejoin="round"
								stroke-width="2.5"
								d="M6 8.256L24.009 3L42 8.256v10.778A26.316 26.316 0 0 1 24.003 44A26.32 26.32 0 0 1 6 19.029z"
							></path>
						</mask>
					</defs>
					<path
						fill="currentColor"
						d="M0 0h48v48H0z"
						mask="url(#ipTShield{random})"></path>
				</svg>
				Secure
			</a>
		</li>
		<li>
			<a
				class="flex flex-row items-center gap-1.5"
				href="/help/others/gdpr-compliant-forms">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="20px"
					height="20px"
					viewBox="0 0 48 48">
					<defs>
						<mask id="ipTSuccess{random}">
							<g
								fill="none"
								stroke="#fff"
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2.5">
								<path
									fill="#555"
									d="m24 4l5.253 3.832l6.503-.012l1.997 6.188l5.268 3.812L41 24l2.021 6.18l-5.268 3.812l-1.997 6.188l-6.503-.012L24 44l-5.253-3.832l-6.503.012l-1.997-6.188l-5.268-3.812L7 24l-2.021-6.18l5.268-3.812l1.997-6.188l6.503.012z"
								></path>
								<path d="m17 24l5 5l10-10"></path>
							</g>
						</mask>
					</defs>
					<path
						fill="currentColor"
						d="M0 0h48v48H0z"
						mask="url(#ipTSuccess{random})"></path>
				</svg>
				GDPR-compliant
			</a>
		</li>
		<li class="flex flex-row items-center gap-1.5">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="20px"
				height="20px"
				viewBox="0 0 48 48">
				<defs>
					<mask id="ipTDevices{random}">
						<g
							fill="none"
							stroke="#fff"
							stroke-linejoin="round"
							stroke-width="2.5">
							<path d="M23 43h20V5H14v10"></path>
							<path fill="#555" d="M5 15h18v28H5z"></path>
							<path stroke-linecap="round" d="M13 37h2m13 0h2"></path>
						</g>
					</mask>
				</defs>
				<path
					fill="currentColor"
					d="M0 0h48v48H0z"
					mask="url(#ipTDevices{random})"></path>
			</svg>
			Mobile-friendly
		</li>
		<li class="flex flex-row items-center gap-1.5">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="20"
				height="20"
				viewBox="0 0 24 24">
				<g
					fill="#c8ccd2"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.25">
					<path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0"></path>
					<path d="m10 16.5l2-3l2 3m-2-3v-2l3-1m-6 0l3 1"></path>
					<circle cx="12" cy="7.5" r=".5" fill="currentColor"></circle>
				</g>
			</svg>
			WCAG2-compliant
		</li>
		<li class="flex flex-row items-center gap-1.5">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="20px"
				height="20px"
				viewBox="0 0 48 48">
				<defs>
					<mask id="ipTFlashlamp{random}">
						<g fill="none" stroke="#fff" stroke-width="2.5">
							<circle cx="24" cy="24" r="20" fill="#555"></circle>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="m23 14l-5 10h12l-5 10"></path>
						</g>
					</mask>
				</defs>
				<path
					fill="currentColor"
					d="M0 0h48v48H0z"
					mask="url(#ipTFlashlamp{random})"></path>
			</svg>
			Blazing fast
		</li>
		<li class="flex flex-row items-center gap-1.5">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="20px"
				height="20px"
				viewBox="0 0 48 48">
				<defs>
					<mask id="ipTGraphicDesign{random}">
						<g
							fill="none"
							stroke="#fff"
							stroke-linejoin="round"
							stroke-width="2.5">
							<path
								d="M19 32c-7.732 0-14-6.268-14-14S11.268 4 19 4s14 6.268 14 14"
							></path>
							<path fill="#555" d="M44 18H18v26h26z"></path>
						</g>
					</mask>
				</defs>
				<path
					fill="currentColor"
					d="M0 0h48v48H0z"
					mask="url(#ipTGraphicDesign{random})"></path>
			</svg>
			Customizable
		</li>
	</ul>
</div>
